<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          color="primary"
          v-bind="attrs"
          v-on="on"
          rounded
          elevation="0"
          class="ml-4"
        >
          <v-row no-gutters justify="center" align="center">
            <v-icon>la-globe-americas</v-icon>
            <span class="ml-1">{{
              items[selected]?.value?.toUpperCase()
            }}</span>
          </v-row>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          v-bind="attrs"
          v-on="on"
          rounded
          elevation="0"
          class="mx-2"
        >
          <v-row no-gutters justify="center" align="center">
            <v-icon>la-globe-americas</v-icon>
            <span class="ml-1">{{
              items[selected]?.value?.toUpperCase()
            }}</span>
          </v-row>
        </v-btn>
      </template>
      <v-list>
        <v-row class="px-4 pb-2" no-gutters>
          <strong class="primary--text">Traduções</strong>
        </v-row>
        <v-list-item-group v-model="selected" color="primary">
          <v-list-item
            :disabled="selected === index"
            v-for="(item, index) in items"
            :key="item.value"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    items: [
      { title: "Português", value: "pt" },
      { title: "Español", value: "es" },
      { title: "English", value: "en" },
    ],
    selected: null,
  }),
  computed: {
    ...mapGetters(["selectedLanguage"]),
  },
  mounted() {
    if (this.selectedLanguage === "pt") this.selected = 0;
    else if (this.selectedLanguage === "es") this.selected = 1;
    else this.selected = 2;
  },
  watch: {
    selected(v) {
      if (this.items[v]?.value) {
        this.$i18n.locale = this.items[v]?.value;
        localStorage.setItem("language", this.items[v]?.value);
        this.$store.commit("SET_SELECTED_LANGUAGE", this.items[v]?.value);
      }
    },
  },
};
</script>
